import type { OrderType } from '@features/products/catalog';
import { EMPTY_BUCKETS, type ProductCountBuckets, type ProductCounts } from '@features/products/counts/productCounts';

// Every product's figures come from that product's shared counts module, so a number on Home is
// the number on the product's tab.

/** Summed across the products in scope. */
export interface RooftopCounts {
  id: number;
  /** The sum of the four buckets. */
  orders: number;
  active: number;
  cancelled: number;
}

export interface HomeCounts {
  /** An absent type reads as zero everywhere. */
  byProduct: Partial<Record<OrderType, ProductCounts>>;
  /** Per rooftop in scope, every listed rooftop present; empty when the breakdown was not asked for. */
  byRooftop: RooftopCounts[];
}

/** No counts at all: what the resolver reads before data arrives. */
export const EMPTY_COUNTS: HomeCounts = { byProduct: {}, byRooftop: [] };

export const bucketsFor = (counts: HomeCounts, orderType: OrderType): ProductCountBuckets => counts.byProduct[orderType]?.buckets ?? EMPTY_BUCKETS;

/** True when the source capped its rows, so the figures are a floor. */
export const truncatedFor = (counts: HomeCounts, orderType: OrderType): boolean => counts.byProduct[orderType]?.truncated ?? false;
